<template>
  <v-tooltip v-if="icon" top>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-icon color="success" :small="small">
          {{ icon }}
        </v-icon>
      </span>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    produto: Object,
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      if (this.produto.produto.finalizado) {
        return 'mdi-check-circle';
      }
      if (this.produto.produto.compra) {
        return 'mdi-progress-check';
      }
      return null;
    },
    text() {
      if (this.produto.produto.finalizado) {
        return 'Este produto foi comprado';
      }

      if (this.produto.produto.compra) {
        return 'Este produto está em processo de compra';
      }
      return null;
    },
  },
};
</script>
